









































































































































































































import { Vue, Component, Prop } from 'vue-property-decorator'
import Loader from '@/components/Loader.vue'
import Preview from './Preview.vue'
import { PurchasedItem, AvailableItem } from './index.vue'
@Component({
	components: {
		Preview,
	},
})
export default class Card extends Vue {
	loading = false
	showPreview = false
	showPreviewDemo = false
	appMode = false //process.env.VUE_APP_ENV == 'dev'

	@Prop(Object) readonly data: any

	openConfirmPurchase() {
		this.$emit('onConfirmPurchase', this.cardData)
	}

	activateItem() {
		this.loading = true
		this.axios({
			method: 'patch',
			url: `eshop/items/purchased/${this.data.id}/activate`,
		})
			.then(({ data }) => {
				this.loading = false
				;(this as any).$toast(this.$t('pageShop.toast.itemActivated'), {
					className: ['btn-info', 'notif'],
					duration: 3000,
				})
				this.$emit('onChangeActivated')
			})
			.catch(e => {
				this.loading = false
				;(this as any).$toast(this.$t('pageShop.toast.error'), {
					className: ['btn-danger', 'notif'],
					duration: 3000,
				})
			})
	}

	deactivateItem() {
		this.loading = true
		this.axios({
			method: 'patch',
			url: `eshop/items/purchased/${this.data.id}/deactivate`,
		})
			.then(({ data }) => {
				this.loading = false
				;(this as any).$toast(this.$t('pageShop.toast.itemDeactivated'), {
					className: ['btn-info', 'notif'],
					duration: 3000,
				})
				this.$emit('onChangeActivated')
			})
			.catch(e => {
				this.loading = false
				;(this as any).$toast(this.$t('pageShop.toast.error'), {
					className: ['btn-danger', 'notif'],
					duration: 3000,
				})
			})
	}

	get isPurchasedView() {
		return typeof this.data.is_activated === 'boolean'
	}
	get cardData() {
		return this.data as AvailableItem | PurchasedItem
	}
	get isActivated() {
		return (this.cardData as PurchasedItem).is_activated
	}
	get status() {
		return (this.cardData as AvailableItem).status
	}
	get isPurchasedItem() {
		return (this.cardData as AvailableItem).is_purchased
	}
	get isBackground() {
		return (
			(this.cardData as AvailableItem)?.category == 'BACKGROUND' ||
			(this.cardData as PurchasedItem)?.item?.category == 'BACKGROUND'
		)
	}
	get isFace() {
		return (
			(this.cardData as AvailableItem)?.category == 'FACE' ||
			(this.cardData as PurchasedItem)?.item?.category == 'FACE'
		)
	}
}
